import React from 'react';
import { MoreVertical } from 'lucide-react';

/**
 * ⋮-Trigger der mobilen Editor-Kopfzeilen. 44px ist die kleinste zuverlässig treffbare
 * Fläche am Finger; der Master-Standard (28px) bleibt unangetastet, weil er app-weit in
 * Tabellen und Kartenmenüs sitzt.
 *
 * Reicht Props und Ref weiter: der Baustein übergibt ihn per `asChild` an Radix, und ein
 * Knopf, der die Radix-Props verschluckt, öffnet nichts.
 */
const MobileMenuTrigger = React.forwardRef(function MobileMenuTrigger({ label, ...rest }, ref) {
  return (
    <button type="button" ref={ref} className="mobile-menu-trigger" aria-label={label} {...rest}>
      <MoreVertical size={16} aria-hidden />
    </button>
  );
});

export default MobileMenuTrigger;
